export default {
  appBg: '#edebea',
  darkWhite: '#f9f9f9',
  lightGray: '#d8d8d8',
  gray: '#979797'
}
